import Header from "../components/layout/Header";
import NotFoundIcon from "../assets/Images/not-found.png";
import Wrapper from "../components/layout/Wrapper";
import Footer from "../components/layout/Footer";
import SEO from "../components/layout/SEO";
import { useLanguage } from "../context/LanguageProvider";

const NotFound = () => {

    const { t } = useLanguage();

    return (
        <>
            <SEO
                title={t.seo.notFound.title}
                description={t.seo.notFound.description}
                path="/not-found"
            />

            <div className="flex flex-col min-h-screen">

                <Header />

                <Wrapper className="flex-1 my-10">

                    <div className="w-1/2 mx-auto">

                        <img
                            src={NotFoundIcon}
                            alt={t.notFound.imageAlt}
                            className="w-3/4 mx-auto"
                        />

                        <p className="text-3xl text-center mt-8">
                            {t.notFound.heading}
                        </p>

                    </div>

                </Wrapper>

                <Footer />

            </div>
        </>
    );
};

export default NotFound;